module.exports = __webpack_public_path__ + "static/media/CompanyProfilemap.414a86c9.png";